<script>
  import Filter from "../../Filter/Filter.svelte";
  import {onMount} from "svelte";
  import {External, M} from "../../external";
  import Dropdown from "../../Common/Dropdown.svelte";
  import MembersTable from "./MembersTable.svelte";
  import {LmsUtils} from "../utils/LmsUtils";

  const ALL_CIRCLES = {
    // name: M.ALL_MEMBERS,
    name: M.ALL_CIRCLES,
    uniqueId: 'all'
  };

  let instance,
    filterInstance,
    filters = [],
    activeCircle = ALL_CIRCLES,
    circles = [ALL_CIRCLES],
    itemsCount = 0;

  let onFilterChange = () => {
    // using setTimeout here to allow for other changes to propagate, for example changing activeCircle
    setTimeout(() => {
      instance.reloadTable();
    }, 1);
  };

  let onCircleChanged = (event) => {
    activeCircle = event.detail.selected;
    onFilterChange();
  };

  let onLoaded = (event) => {
    itemsCount = event.detail.count;
  }

  onMount(async () => {
    filterInstance.onFilterChanged();
    let existingCircles = await LmsUtils.listCircles();
    circles = [ALL_CIRCLES, ...existingCircles];
  });
</script>

<div class="full-size flex flex-row-col-responsive flex-col">
  <div class="account-settings flex-1 horizontal-flex-table col20"
       style="font-family: 'Roboto';">
    <div class="top-background-wrapper wide-top-background" style="padding-top:20px;">
      <div class="top-background filter-wrapper-outer" style="max-width:1200px;">
        <Filter
          enableOR={true}
          enableSaveSegment={false}
          bind:this={filterInstance}
          bind:filters
          onChange={onFilterChange}/>
      </div>
      <div class="top-background" style="max-width:1200px;">
        <div
          class="text-wrapper f-left col20 flex align-center space-between mobile-row flex-col-tablet flex-start-mobile">
          <div class="flex-centered f-left">
            <h2 class="crm-title crm-title-bigger f-left">
              {activeCircle.name} <i class="fa fa-circle"/>
            </h2>
            <h2 class="crm-title f-left">
              {itemsCount}
              {M.MEMBERS}
            </h2>
            <h4 class="ml-15 hide-mobile">{M.FOR}</h4>
            <Dropdown items={circles} activeItem={activeCircle} on:change={onCircleChanged} class="ml-15"/>
          </div>
          <div style="flex:none;">
            <div class="f-right flex-centered">
              <a
                class="crm-option"
                style="margin-left: 10px; padding-right: 33px;"
                on:click={(e) => instance.showColumnOptions(e)}>
                {M.COLUMNS}
                <svg class="interface-icon o__standard" xmlns="http://www.w3.org/2000/svg" width="20"
                     height="21" viewBox="0 0 16 16">
                  <path d="M4 6l4 4 4-4H4z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper horizontal-flex-table" style="max-width:1200px; width: 94%;">
      <div class="sections-wrapper members-wrapper horizontal-flex-table">
        <div class="section-bg members-wrapper products-wrapper crm-table-outer">
          <MembersTable filters={filters} bind:this={instance} circleId={activeCircle.id} on:itemsloaded={onLoaded}/>
        </div>
      </div>
    </div>
  </div>
</div>
